import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  // Price details
  billingDetails: {
    padding: theme.spacing(5, 8, 4),
    borderBottom: `1px solid ${theme.onCardDivider.beige_50_op_70}`
  },
  billingInfo: {
    marginBottom: 0
  },
  pastDueRow: {
    backgroundColor: theme.colorPalette.red_100
  },
  holdPaymentButton: {
    padding: 0,
    fontWeight: 600
  },
  holdPaymentButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  holdPaymentWarning: {
    display: 'flex'
  },
  manualChargeContainer: {
    padding: theme.spacing(4, 8),
    borderBottom: `1px solid ${theme.onCardDivider.beige_50_op_70}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  rowTitle: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  // Payment Details
  tableBodyPaymentMethodLast4: {
    display: 'inline-flex',
    color: theme.onCard.beige_50_op_60,
    width: 'auto',
    fontSize: 12,
    fontWeight: 'bold',
    '& > span': {
      margin: '0 4px'
    }
  },
  creditCardLast4: {
    composes: '$tableBodyPaymentMethodLast4',
    display: 'block',
    fontSize: 16,
    width: '50%'
  },
  tableRow: {
    height: 47,
    borderBottom: `1px solid ${theme.onCardDivider.beige_50_op_70}`,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  tableCell: {
    borderBottom: 'none',
    color: theme.colors.light_text,
    fontSize: 14
  },
  sectionContainer: {
    padding: theme.spacing(4, 8)
  },
  refundToggle: {
    marginLeft: 'auto'
  },
  // manual charge
  submit: {
    width: 200,
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(6)
  },
  spaceBetweenRow: {
    justifyContent: 'space-between'
  },
  totalRemainingField: {
    marginTop: theme.spacing(6),
    marginLeft: theme.spacing(2)
  },
  manualChargeForm: {
    paddingTop: theme.spacing(2)
  },
  loadingBar: {
    height: 2
  },
  stripeCustomerLink: {
    color: theme.colors.action_text,
    fontWeight: 500,
    // The global `a` rule sets display: contents, which leaves no box to draw the hover underline on
    display: 'inline',
    '&:hover': {
      textDecoration: 'underline'
    },
    ...reskinStyles(theme, theme.actionStyles.link)
  },
  // Agency sweep-account setup hint (#33155): underlined inline text that reveals the
  // "set up a sweep account" instruction on hover.
  sweepAccountHint: {
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
    cursor: 'help'
  },
  sweepAccountHintRow: {
    marginTop: theme.spacing(1)
  },
  warningText: {
    fontSize: 10,
    margin: 0,
    color: theme.onCard.white,
    justifyContent: 'center'
  },
  refundSectionContainer: {
    padding: theme.spacing(4, 8),
    display: 'flex',
    flexDirection: 'column',
    borderTop: `1px solid ${theme.onCardDivider.beige_50_op_70}`
  },
  paymentRow: {
    marginTop: theme.spacing(1)
  },
  refundButton: {
    width: 154,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(6)
  },
  smallIcon: {
    width: 15,
    height: 15
  },
  centeredContentContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    justifyContent: 'center',
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colors.light_text,
    padding: theme.spacing(2),
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, borderRadius: theme.sizes.innerCorners })
  }
});

export default makeStyles(styles);
